export default __webpack_public_path__ + "static/media/ja.5fd66bb0.png";